import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { useEventUsersDrawer } from './useEventUsersDrawer';

interface EventUsersDrawerProps {
  excludeUserIds?: string[];
  isOpen: boolean;
  hasPaid?: boolean;
  onClose: () => void;
  eventId: string;
  onUserSelected: (userId: string) => void;
}

export const EventUsersDrawer: FunctionComponent<EventUsersDrawerProps> = ({
  excludeUserIds,
  isOpen,
  hasPaid,
  onClose,
  eventId,
  onUserSelected,
}) => {
  const { clearSearch, eventUsers, onSearchChange, search } =
    useEventUsersDrawer(eventId, hasPaid, excludeUserIds);

  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={onClose}>
        <Box sx={{ mt: 10, mx: 2, width: 360 }}>
          <Typography variant="h4">{"Utilisateurs de l'événement"}</Typography>
          <TextField
            label="Rechercher un participant"
            size="small"
            value={search}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: <SearchIcon />,
              endAdornment:
                search.length > 0 ? (
                  <InputAdornment position="end">
                    <IconButton onClick={clearSearch} onMouseDown={clearSearch}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : undefined,
            }}
          />
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {eventUsers.map((user) => (
              <div key={user.id}>
                <ListItem
                  alignItems="flex-start"
                  secondaryAction={
                    <IconButton
                      color="primary"
                      onClick={() => onUserSelected(user.id)}
                    >
                      <AddIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={`${user.firstname} ${user.lastname}${user.nickname ? ` (${user.nickname})` : ''}`}
                    secondary={
                      <Box flexDirection="column" display="flex">
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                          {user.studyTown}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </div>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};
